import { Box } from '@mui/material';
import QRCode from 'components/qr-code/qr-code.component';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getGiftCardByToken } from '../../../redux/user/user.actions';
import { selectIsHideQrCode } from 'redux/config/config.selectors';
import GiftCardDetails from './giftcard-details/giftcard-details.component';
import GiftcardViewWrapper from './giftcard-view-wrapper/giftcard-view-wrapper.component';

const GiftcardViewPage = () => {
  const { token } = useParams();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [giftcard, setGiftcard] = useState({});
  const hideQrCode = useSelector(selectIsHideQrCode);

  useEffect(() => {
    dispatch(getGiftCardByToken(token)).then(response => {
      setIsLoading(false);
      response?.data && setGiftcard(response.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <GiftcardViewWrapper isLoading={isLoading} giftcard={giftcard}>
      <GiftCardDetails giftcard={giftcard} />
      {!hideQrCode && (
        <Box mb={1}>
          <QRCode
            value={giftcard?.cardIdentifier}
            data-testid="GiftcardView.QRCode"
          />
        </Box>
      )}
    </GiftcardViewWrapper>
  );
};

export default GiftcardViewPage;
